<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useUiStore } from '@/stores/ui';

const ui = useUiStore();
const typed = ref('');
watch(
  () => ui.confirmState,
  () => (typed.value = ''),
);
const canConfirm = computed(
  () => !ui.confirmState?.requireText || typed.value.trim() === ui.confirmState.requireText,
);
const btnClass = computed(() => `btn btn-${ui.confirmState?.variant ?? 'primary'}`);
</script>

<template>
  <Teleport to="body">
    <div
      v-if="ui.confirmState"
      class="modal fade show d-block kl-confirm"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      @click.self="ui.resolveConfirm(false)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" :class="{ 'bg-danger text-white': ui.confirmState.variant === 'danger' }">
            <h5 class="modal-title">{{ ui.confirmState.title }}</h5>
            <button
              type="button"
              class="btn-close"
              :class="{ 'btn-close-white': ui.confirmState.variant === 'danger' }"
              aria-label="Sluiten"
              @click="ui.resolveConfirm(false)"
            ></button>
          </div>
          <div class="modal-body">
            <p style="white-space: pre-line" class="mb-2">{{ ui.confirmState.message }}</p>
            <div v-if="ui.confirmState.requireText" class="mt-3">
              <label class="form-label small"
                >Typ <code>{{ ui.confirmState.requireText }}</code> ter bevestiging</label
              >
              <input
                v-model="typed"
                class="form-control"
                autofocus
                @keyup.enter="canConfirm && ui.resolveConfirm(true)"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" @click="ui.resolveConfirm(false)">
              {{ ui.confirmState.cancelLabel }}
            </button>
            <button type="button" :class="btnClass" :disabled="!canConfirm" @click="ui.resolveConfirm(true)">
              {{ ui.confirmState.confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="ui.confirmState" class="modal-backdrop fade show kl-confirm-backdrop"></div>
  </Teleport>
</template>
